import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

import { ContainerStyled } from './Alert.styles';

export function Alert(props) {
  const { alertTitle } = props;

  return (
    <ContainerStyled>
      <FiAlertCircle />
      <Typography variant="h1">{alertTitle}</Typography>
    </ContainerStyled>
  );
}

Alert.propTypes = {
  alertTitle: PropTypes.string.isRequired,
};
